import { Hide, Image, Show } from '@chakra-ui/react';
import React from 'react';
import { Link } from 'react-router-dom';
import logoDesktop from '@/assets/slambet/images/header/logo.png';
import logoMb from '@/assets/slambet/images/header/logoMb.png';
import { THEME_NAME } from '@/constants/themeConfig';

export default function index() {
  return (
    <Link to="/">
      <Show above="lg">
        <Image src={logoDesktop} alt={THEME_NAME.slambet} mx="auto" pb={2} />
      </Show>
      <Hide above="lg">
        <Image src={logoMb} alt={THEME_NAME.slambet} h="8" />
      </Hide>
    </Link>
  );
}
